import React, { useState, FC, useEffect, useRef, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { formatPhoneNumber } from '../../../../../utils';
import { Icon, IconDelete } from '../../../base/icons';
import Card from '../atoms/Card';
import GroupKeyboard from '../molecules/GroupKeyboard';
import { updateDialInNumbers } from '../../../invite/actions';
import {
    _getDefaultPhoneNumber,
} from '../../../invite/functions';
import UserList from "./UserList";
declare var APP: Object;
const row1 = [
    {
        id: 0,
        number: '1',
        pad: ''
    },
    {
        id: 1,
        number: '2',
        pad: 'a b c'
    },
    {
        id: 2,
        number: '3',
        pad: 'd e f'
    }
];
const row2 = [
    {
        id: 3,
        number: '4',
        pad: 'g h i'
    },
    {
        id: 4,
        number: '5',
        pad: 'j k l'
    },
    {
        id: 5,
        number: '6',
        pad: 'm n o'
    }
];
const row3 = [
    {
        id: 6,
        number: '7',
        pad: 'p q r s'
    },
    {
        id: 7,
        number: '8',
        pad: 't u v'
    },
    {
        id: 8,
        number: '9',
        pad: 'w x y z'
    }
];
const row4 = [
    {
        id: 9,
        number: '*',
        pad: ''
    },
    {
        id: 10,
        number: '0',
        pad: '+'
    },
    {
        id: 11,
        number: '#',
        pad: ''
    }
];

export interface RowData {
    id: number;
    number: string;
    pad: string;
}

export interface NumericKeyPadProps {
    value?: string,
    onChange?: () => void,
    onSubmit?: (key: string) => void,
    openRecentCall?: () => void,
    onOpenRecentCall?: () => void,
    openCreateGroup?: () => void
}

const NumericKeyPad: FC<NumericKeyPadProps> = ({ value, onChange, onSubmit, openRecentCall, onOpenRecentCall, openCreateGroup }) => {
    const [ valueKey, setValueKey ] = useState('');
    const { conference } = useSelector(state => state['features/base/conference']);
    const dialIn = useSelector(state => state['features/invite']);

    const [defaultNumber, setDefaultNumber] = useState('');
    const [isOpenRecentCall, setIsOpenRecentCall] = useState(false);

    const numberRef = useRef();
    const dispatch = useDispatch()

    useEffect(() => {
        if (value !== undefined && value !== valueKey) {
            setValueKey(value);
        }
    }, [ value ]);

    const handleChange = newValueKey => {
        setValueKey(valueKey + newValueKey);
        onChange(valueKey + newValueKey);
    };

    const handleDelete = () => {
        const newString = valueKey.slice(0, -1);

        setValueKey(newString);
    };

    const handleOnSubmit = () => {
        if (valueKey) {
            onSubmit(valueKey);
        }
    };

    useLayoutEffect(() => {
        if (valueKey) {
            numberRef.current.focus();
        }
    }, [ valueKey ]);
    useEffect(()=>{
        numberRef.current.focus();
    },[])
    useEffect(() => {
        if (!dialIn?.conferenceID && conference?.room?.joined) {
            const updateNumbers = updateDialInNumbers();

            updateNumbers(dispatch, APP.store.getState );
        }
    }, [ conference ]);
    useEffect(()=>{
        if(dialIn && dialIn.numbers ){
            const defaultnumber = _getDefaultPhoneNumber(dialIn.numbers)
            if(defaultnumber){
                setDefaultNumber(defaultnumber)
            }
        }

    },[dialIn && dialIn.numbers ])
    const onKeyUp = (event) =>{

        if (event.keyCode >= 48 && event.keyCode <= 57) {
            // 0-9 only
            //console.log(event.keyCode)
            const newValueKey = event.keyCode - 48
            setValueKey(valueKey + newValueKey);
            onChange(valueKey + newValueKey);
        }
        if(event.keyCode >= 96 && event.keyCode <= 105){
            // handle numberpad
            //console.log(event.keyCode)
            const newValueKey = event.keyCode - 96
            setValueKey(valueKey + newValueKey);
            onChange(valueKey + newValueKey);
        }
        if(event.keyCode === 8){
            //console.log("backspace");
            handleDelete();
        }
        if(event.keyCode === 13){
            handleOnSubmit();
        }
    }
    return (
        <div>
            {!isOpenRecentCall && <Card className='o-numeric-keypad'>
                <div className='mobile-keypad-wrapper dis-flex flex-column jus-center flex-1'>
                    <div className='o-numeric-keypad--input'>
                        <input
                            className='o-numeric-keypad--number'
                            ref={numberRef}
                            value={`+1${valueKey.trim() ? formatPhoneNumber(valueKey) : ' ( ) - -'}`}
                            onKeyUp={onKeyUp}
/*                             disabled = { true }
 */                        />
                    </div>
                    <div className='o-numeric-keypad--group'>
                        <GroupKeyboard
                            data={row1}
                            onClick={handleChange}/>
                        <GroupKeyboard
                            data={row2}
                            onClick={handleChange}/>
                        <GroupKeyboard
                            data={row3}
                            onClick={handleChange}/>
                        <GroupKeyboard
                            data={row4}
                            onClick={handleChange}/>
                        <div className='o-numeric-keypad--group--call'>
                            <button
                                className='o-numeric-keypad--group--btn'
                                onClick={handleOnSubmit}>
                                <img
                                    src='../../../../../images/keyboard-call.svg'
                                    width='85'
                                    height='85'/>
                            </button>
                            {valueKey && <div
                                className={'o-numeric-keypad--group--call--delete'}>
                                <div onClick={handleDelete}>
                                    <Icon
                                        src={IconDelete}
                                        size={30}/>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={'o-numeric-keypad--default'}>
                    <div className={'o-numeric-keypad-recent-call'}>
                        <div
                            className={'o-numeric-keypad-recent-call-button'}
                            onClick={openRecentCall}>
                            <p>Recent Calls</p>
                        </div>
                    </div>
                </div>
                <div className={'o-numeric-keypad--new'}>
                    <div className={'o-numeric-keypad-recent-call'}>
                        <div
                            className={'o-numeric-keypad-recent-call-button'}
                            onClick={() => setIsOpenRecentCall(true)}>
                            <p>Recent Calls</p>
                        </div>
                    </div>
                </div>
                {conference && <div>
                    pin:{dialIn?.conferenceID}
                    <br/>
                    dial number: {defaultNumber}
                </div>}
            </Card>}
            {
                isOpenRecentCall && <div className = { 'o-numeric-keypad-wrapper' }>
                    <div className = { 'o-numeric-keypad-wrapper--keypad' }>
                        <Card className = 'o-numeric-keypad'>
                            <div className = 'dis-flex flex-column jus-center flex-1'>
                                <div className = 'o-numeric-keypad--input'>
                                    <input
                                        className = 'o-numeric-keypad--number'
                                        ref = { numberRef }
/*                                         disabled = { true }
 */                                        value = { `+1${valueKey.trim() ? formatPhoneNumber(valueKey) : ' ( ) - -'}` }
                                        onKeyUp={onKeyUp}
                                    />
                                </div>
                                <div className = 'o-numeric-keypad--group'>
                                    <GroupKeyboard
                                        data = { row1 }
                                        onClick = { handleChange } />
                                    <GroupKeyboard
                                        data = { row2 }
                                        onClick = { handleChange } />
                                    <GroupKeyboard
                                        data = { row3 }
                                        onClick = { handleChange } />
                                    <GroupKeyboard
                                        data = { row4 }
                                        onClick = { handleChange } />
                                    <div className = 'o-numeric-keypad--group--call'>
                                        <button
                                            className = 'o-numeric-keypad--group--btn'
                                            onClick = { handleOnSubmit }>
                                            <img
                                                src = '../../../../../images/keyboard-call.svg'
                                                width = '85'
                                                height = '85' />
                                        </button>
                                        {valueKey && <div className = { 'o-numeric-keypad--group--call--delete' }>
                                            <div onClick = { handleDelete }>
                                                <Icon
                                                    src = { IconDelete }
                                                    size = { 30 } />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {conference && <div>
                                pin:{dialIn?.conferenceID}
                                <br />
                                dial number: {defaultNumber}
                            </div>}
                        </Card>
                    </div>
                    <div className = { 'recent-call-wrapper' }>
                        <UserList
                            onChange = { onChange }
                            openCreateGroup = { openCreateGroup }
                        />
                    </div>
                </div>
            }
        </div>
    );
};

NumericKeyPad.defaultProps = {
    value: '',
    onChange: () => { },
    onSubmit: () => { },
    openRecentCall: () => {}
};
export default NumericKeyPad;
